import { productSelectors } from '@ynap/product-state'
import { formatDate, formatPrice } from '@ynap/intl-formatters'
import { pdpSelectors } from '@ynap/product-details-state'

const { getProductLinkByPartNumber } = productSelectors
const { getSelectedProductImages } = pdpSelectors

export default function getReservations(state) {
    const {
        reservations,
        fetchReservationsError,
        addToCart,
        config,
        appState: { locale },
    } = state
    const items =
        reservations && reservations.skus
            ? reservations.skus.map((item) => {
                  const reservationDetails = getReservationDetails(item, locale, config)
                  const pdpDetails = mapPdpSkuDetail(reservationDetails, item.skus, config, locale)
                  return {
                      ...reservationDetails,
                      details: pdpDetails,
                  }
              })
            : undefined

    return {
        reservations: items,
        addToCartResponse: addToCart,
        fetchReservationsError,
    }
}

export const getReservationDetails = (reservationItem, locale, config) => {
    const sku = reservationItem.skus
    const badges = sku?.badges?.filter((badge) => badge.type !== 'STOCK')
    const noTimeZone = /\d{4}-\d{2}-\d{2}$/.test(reservationItem?.expiryDateTime) // Check if date doesn't have a timeZone
    const dateFormatOptions = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        ...(noTimeZone && { timeZone: 'UTC' }),
    }
    const { sellingPrice, currency, wasPrice, discount } = sku?.price || {}
    const imagesphereAspectRatio = config?.head?.aspectRatio?.imagesphere || ''

    const parsedLocale = locale.locale.replace('_', '-')

    const reservationExpiryDate = reservationItem?.expiryDateTime
        ? formatDate(new Date(reservationItem.expiryDateTime), dateFormatOptions, parsedLocale).toUpperCase()
        : null

    return {
        partNumber: sku.partNumber ? sku.partNumber : '',
        image: sku.imageTemplate
            ? sku.imageTemplate.replace('{view}', 'in').replace('{width}', `300${imagesphereAspectRatio || ''}`)
            : '',
        brand: sku.designerName ? sku.designerName : '',
        name: sku.shortDescription || sku.name || '',
        colour: sku.label,
        size: sku.size?.centralSizeLabel || sku.size?.labelSize || '',
        quantity: '1',
        price: sku.price
            ? {
                  originalPrice: wasPrice
                      ? formatPrice(wasPrice.amount / wasPrice.divisor, currency.label, locale.id)
                      : formatPrice(sellingPrice.amount / sellingPrice.divisor, currency.label, locale.id),

                  markedDownPercentDiscount: discount ? discount.amount / discount.divisor : null,
                  markedDownPrice: wasPrice
                      ? formatPrice(sellingPrice.amount / sellingPrice.divisor, currency.label, locale.id)
                      : null,
                  priceReduced: !!discount,
              }
            : null,
        badges,
        reservationExpiryDate,
        reservationId: reservationItem.reservationId || '',
    }
}

export const mapPdpSkuDetail = (details, sku, config, locale) => {
    const { price, imageTemplate, imageViews, partNumber, label, size, seo } = sku
    const { badges, name, brand, reservationId, quantity } = details
    const product = { name, designerName: brand }
    const availableImageSizes = config.head ? config.head.availableImageSizes : config.availableImageSizes
    const productUrlTemplate = config?.global?.urlConfig?.pdp?.construct || ''

    const productUrl = getProductLinkByPartNumber(productUrlTemplate, locale.id, seo, partNumber)
    const imagesphereAspectRatio = config?.head?.aspectRatio?.imagesphere || ''
    return {
        reservationId,
        product,
        productUrl,
        selectedProductVariant: {
            images: getSelectedProductImages(
                product,
                {
                    imageTemplate,
                    imageViews,
                },
                availableImageSizes,
                null,
                null,
                imagesphereAspectRatio
            ),
            price: formatLitePdpPrice(price),
            badges,
            colourPartNumber: partNumber,
            colourSwatches: [],
            label: label,
            buyable: { canAddToBag: true }, //keeping the logic for canAddToBag, but it should not rely on buyable flag as it is for public not for reservation
            sKUs: [sku],
        },
        selectedSku: { partNumber },
        selectedSizeLabel: size.centralSizeLabel || size.labelSize,
        quantity: {
            initialQuantity: quantity,
            minQuantity: quantity,
            maxQuantity: quantity,
        },
    }
}

/**
 * Formats price as expected by pdp/Layouts/Lite
 * @param {Object} price
 */
export const formatLitePdpPrice = (price) => {
    if (!price) {
        return null
    }
    const { sellingPrice, ...restPrice } = price

    return {
        finalPrice: sellingPrice.amount / sellingPrice.divisor,
        ...restPrice,
    }
}
